<template>
  <v-data-table
    id="customers-page-database-user-table"
    v-model="selected"
    :headers="headers"
    :items="lastOptInUsersTable"
    hide-default-footer
    show-select
    class="theme-table-disjointed"
    @click:row="rowClicked"
  >
    <template v-slot:body.prepend v-if="hasSelection">
      <tr class="ignore group-actions">
        <td colspan="12">
          <span>Actions sur la sélection : </span>
          <!-- <v-btn outlined color="white" class="ml-3">
            <v-icon class="mr-1 material-icons-outlined" small>archive</v-icon>
            Archiver
          </v-btn> -->
          <v-btn @click="deleteSelectedCustomers()" outlined color="white" class="ml-3">
            <v-icon class="mr-1 material-icons-outlined" small>delete</v-icon>
            Supprimer
          </v-btn>
          <v-btn outlined color="white" class="ml-3" @click="selected = []">
            Annuler
          </v-btn>
        </td>
      </tr>
    </template>
    <template v-slot:item.data-table-select="{ isSelected, select }">
      <v-icon
        v-if="isSelected"
        class="material-icons-outlined"
        color="#6b5cd7"
        @click="select(false)"
        >check_box</v-icon
      >
      <v-icon
        v-else
        class="material-icons-outlined"
        color="#6b5cd7"
        @click="select(true)"
        >check_box_outline_blank</v-icon
      >
    </template>
    <template v-slot:item.optin="{ item }">
      <span v-show="item.optin" class="text-success">Oui</span>
      <span v-show="!item.optin" class="text-danger">Non</span>
    </template>
    <template v-slot:item.segments="{ item }">
      <v-tooltip bottom v-for="(seg, sgeid) in item.segments" :key="sgeid">
        <template v-slot:activator="{ on, attrs }">
          <span
            class="segment-item mr-2"
            v-bind="attrs"
            v-on="on"
            :class="{
              'segment-color-green': seg.color === 'green',
              'segment-color-orange': seg.color === 'orange',
              'segment-color-purple': seg.color === 'purple',
              'segment-color-blue': seg.color === 'blue',
              'segment-color-green-dark': seg.color === 'green-dark',
              'segment-color-pink': seg.color === 'pink',
            }"
          />
        </template>
        <span>{{ seg.label }}</span>
      </v-tooltip>
    </template>
    <template v-slot:item.action="{ item }">
      <v-btn @click="displayDetail(item)" class="theme-btn filled-purple-alt shape-rounded size-small">Details</v-btn>
    </template>
  </v-data-table>
</template>

<script type="text/javascript">
export default {
  components: {},
  props: {},
  data() {
    return {
      headers: [
        {
          text: 'ID Client',
          sortable: true,
          value: 'id',
        },
        {
          text: 'Prénom',
          sortable: true,
          value: 'firstname',
        },
        {
          text: 'Nom',
          sortable: true,
          value: 'lastname',
        },
        {
          text: 'Email',
          sortable: true,
          value: 'email',
        },
        {
          text: "Date d'inscription",
          sortable: true,
          value: 'created_at',
        },
        {
          text: 'Téléphone',
          sortable: true,
          value: 'phone_number',
        },
        {
          text: 'Segments attribués',
          sortable: true,
          value: 'segments',
        },
        {
          text: 'Actions',
          sortable: false,
          value: 'action',
        },
      ],
      selected: [],
    };
  },
  computed: {
    filterSearch() {
      return this.$store.state.customer.customerFilters.search;
    },
    filterSegment() {
      return this.$store.state.customer.customerFilters.selectedSegments;
    },
    lastOptInUsersTable() {
      if (this.$store.state.customer.customers !== null) {
        return this.$store.state.customer.customers
        // .filter((item) => {
        //   if (this.filterSearch !== null && this.filterSearch !== '') {
        //     if (
        //       !item.firstname.toLowerCase().includes(this.filterSearch) &&
        //       !item.lastname.toLowerCase().includes(this.filterSearch) &&
        //       !item.phone_number.toLowerCase().includes(this.filterSearch)
        //     ) {
        //       return false;
        //     }
        //   }
        //   if (this.filterSegment.length > 0) {
        //     let found = false;
        //     for (let i in item.segments) {
        //       if (this.filterSegment.includes(item.segments[i].code)) {
        //         found = true;
        //         break;
        //       }
        //     }
        //     if (!found) {
        //       return false;
        //     }
        //   }
        //   return true;
        // });
      } else {
        return [];
      }
    },
    hasSelection() {
      return this.selected.length > 0;
    },
  },
  created() {
    this.$store.dispatch('customer/loadCustomerData');
  },
  methods: {
    openDrawer(item) {
      this.$eventHub.$emit('openDrawer', item);
    },
    rowClicked(item, data, event) {
      this.$emit('row-clicked', item);
    },
    displayDetail(item) {
      this.$emit('display-detail', item);
    },
    deleteSelectedCustomers() {
      this.$store.dispatch('customer/deleteCustomers', this.selected)
    }
  },
};
</script>

<style lang="scss">
#customers-page-database-user-table {
  .group-actions {
    background-color: $color-secondary;
    color: white;
    height: 64px;
  }

  .segment-item {
    display: inline-block;
    border-radius: 50%;
    width: 22px;
    height: 22px;

    &.segment-color-green {
      background-color: $green-lighten-1;
    }
    &.segment-color-orange {
      background-color: $orange-lighten-1;
    }
    &.segment-color-purple {
      background-color: $purple-alt;
    }
    &.segment-color-blue {
      background-color: $blue-base;
    }
    &.segment-color-green-dark {
      background-color: $green-dark;
    }
    &.segment-color-pink {
      background-color: $pink-base;
    }
  }

  .table-menu-trigger {
    background-color: $purple-lighten-3-3;
    color: $black-base;
    box-shadow: none;
    border-radius: 50px;
    font-size: 12px;
    text-transform: initial;
    padding: 5px 15px;
    height: fit-content;
    transition-duration: 0.2s;

    i {
      position: relative;
      top: 1px;
      color: $black-base;
    }

    &:hover,
    &:focus {
      background-color: $purple-lighten-1;
      color: white;
      i {
        color: white;
      }
    }
  }
}

.table-menu {
  box-shadow: none !important;
  border-radius: 16px !important;
  border: $border-purple;
  margin-top: 3px;

  .v-list {
    padding-top: 0px;
    padding-bottom: 0px;

    & > .v-list-item {
      min-height: initial;
      text-align: center;
      padding: 5px 10px;
      .v-list-item__title {
        color: $purple-alt;
        font-size: 12px;
      }
    }

    & > .v-list-item:nth-child(2n) {
      background-color: $purple-lighten-3-3;
    }
  }
}
</style>
